/*Header */
// jQuery(document).ready(function($) {
//   // Cache the image element and the current image source
//   var $changeImage = $('#changeimage');
//   var currentImageSrc = '';
//
//   // Handle hover on menu items
//   $('.headermenu li').hover(function() {
//     var dataImage = $(this).data('image');
//     if (dataImage !== currentImageSrc) {
//       $changeImage.attr('src', dataImage);
//       currentImageSrc = dataImage;
//     }
//   }, function() {
//     // Clear the image source when the mouse leaves the menu item
//     if (currentImageSrc !== '') {
//       $changeImage.attr('src', currentImageSrc);
//     }
//   });
//
//   // Initialize variables for animation
//   var mouseX = 0;
//   var mouseY = 0;
//   var imageX = 0;
//   var imageY = 0;
//   var imageWidth = $changeImage.width();
//   var imageHeight = $changeImage.height();
//   // Function to update mouse position
//   function updateMousePosition(e) {
//     mouseX = e.clientX;
//     mouseY = e.clientY;
//   }
//
//   // Function to smoothly move the image
//   function moveImage() {
//     var dx = (mouseX - imageX) * 0.05 - imageWidth/2;
//     var dy = (mouseY - imageY) * 0.05 - imageHeight/2;
//
//     imageX += dx;
//     imageY += dy;
//
//     $changeImage.css({
//       transform: `translate(${imageX}px, ${imageY}px)`,
//     });
//
//     requestAnimationFrame(moveImage);
//   }
//
//   // Attach mousemove event listener to update the mouse position
//   $(document).on('mousemove', updateMousePosition);
//
//   // Start the animation
//   requestAnimationFrame(moveImage);
// });

/**/

// jQuery(document).ready(function($) {
// $( "#menu-main-menu li").each(function( index ) {
//     var img_src=$(this).find('a').find('img').attr('src');
//     if(index==1){
//       $('#changeimage').attr('src',img_src);
//     }
// });
// });
// $( "#menu-main-menu li").each(function( index ) {
//       var img_src=$(this).find('a').find('img').attr('src');
//       $(this).attr('data-image',img_src);
// });

/*scroll header*/
$(window).scroll(function() {
  if ($(document).scrollTop() > 700) {
      $('.header_wrapper').addClass('scrolled');
  }
  else{
    $('.header_wrapper').removeClass('scrolled');
  }
});

/*Detect Direction*/
var lastScrollTop = 0;
$(window).scroll(function(event){
   var st = $(this).scrollTop();
   if (st > lastScrollTop){
       // downscroll code
       $('.header_wrapper').addClass('down');
   } else {
      // upscroll code
      $('.header_wrapper').removeClass('down');
   }
   lastScrollTop = st;
});


/*Language Switcher*/
$(".language.is-active").on('click', function() {
    return false;
})

/*Open Menu*/
$(".menu_button").on('click', function() {

      if($(this).hasClass('is-active')){
          //$('#changeimage').css('opacity','0');
          $("body").css('overflow-y','scroll');
          $(this).removeClass('is-active');
          $('.menu_button').removeClass('is-active');
          $('.header_menu_controls .menu_button').addClass('is-active');
          $('.headermenu').removeClass('is-active');
          $('.header_wrapper').removeClass('openmenu');
          //$('.menu li').removeClass('aos-animate');
        }
        else{
        //  $('#changeimage').css('opacity','1');
          $(this).addClass('is-active');
          $('.header_menu_controls .menu_button').addClass('is-active');
          jQuery("body").css('overflow-y','hidden');
          $('.headermenu').addClass('is-active');
          $('.header_wrapper').addClass('openmenu');
      }


});



/*Gallery*/
          import Swiper, { Navigation } from 'swiper';
          const gallery_swi = new Swiper(".gallery_swipe", {
            loop: true,
             freeMode: true,
             spaceBetween: 25,
             grabCursor: true,
             slidesPerView: "auto",
             loop: true,
             autoplay: {
               delay: 1,
               disableOnInteraction: true
             },
             speed: 15000,
             freeModeMomentum: false
          });


/*Featured Image animation*/
if($('body').hasClass('home')){
  if ($(window).width() >768) {
    const image = document.getElementById('shrink');

    // Define the initial scale factor (1.0 = 100%)
    let scale = 1.0;
    const maxScale = 0.84; // Maximum scale value

    // Define the function to update the image scale
    function updateImageScale() {
        const easing = easeOutQuart(scale);
        image.style.transform = `scale(${scale})`;
    }

    function easeOutQuart(t) {
                return 1 - (1 - t) ** 4;
            }

    // Handle the scroll event using requestAnimationFrame
    let lastKnownScrollPosition = 0;

    function onScroll() {
        requestAnimationFrame(() => {
            const currentScrollPosition = window.scrollY;

            // Calculate the new scale factor based on the scroll position
            scale = 1.0 - (currentScrollPosition / 3000); // Adjust the division factor as needed

            // Limit the scale factor within a specific range (e.g., between 0.5 and the maxScale)
            scale = Math.max(maxScale, Math.min(1.0, scale));

            // Update the image scale
            updateImageScale();

            // Store the current scroll position for the next frame
            lastKnownScrollPosition = currentScrollPosition;
        });
    }

    // Attach the scroll event listener
    window.addEventListener('scroll', onScroll);

    // Initial call to set the initial scale
    updateImageScale();
  }
}



/*Mansonry*/
// if ($(window).width() > 768) {
//   var $grid = $('.post-wrapper').imagesLoaded(function () {
//     // init Masonry after all images have loaded
//     $grid.masonry({
//       itemSelector: '.post',
//       gutter: 180,
//       horizontalOrder: true,
//       fitWidth: true
//     });
//   });
// }

/*Calculate image height for mobile*/
$(document).ready(function($) {
    if ($(window).width()<=768) {
      var img_height_suites=0;
      $( "#suites .images img").each(function( index ) {
          if(index==1){

          }else{
            img_height_suites=img_height_suites + $(this).height();
          }
      });
      var img_height_athens=0;
      $( "#athens .images img").each(function( index ) {
        if(index==1){

        }else{
          img_height_athens=img_height_athens + $(this).height();
        }
      });


    $('#suites .wrapper').css('padding-bottom',img_height_suites);
    $('#athens .wrapper').css('padding-bottom',img_height_athens);
}
});

$(document).ready(function($) {
  if($('body').hasClass('page-template-tmpl_philosophy')){
      $('svg').addClass('active');
  }
});
  /*Amenities custom accordion*/
  $('#amenities .wrapper ul li').on('click', function() {
        if($(this).hasClass('active')){
          $(this).removeClass('active');
          $(this).find('ul').find('li').slideUp();
        }else{
          $(this).addClass('active');
          $(this).find('ul').find('li').slideDown();
        }
  });
